<app-form *ngIf="uploadOrderTemplate" [configData]=uploadOrderTemplate></app-form>
